var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthLayout',{attrs:{"current-step":_vm.currentStep,"many-steps":""}},[_c('Register',{model:{value:(_vm.currentStep),callback:function ($$v) {_vm.currentStep=$$v},expression:"currentStep"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }